import { useEffect, useRef } from 'react';
import { useUploadNotification } from '../../context/UploadNotificationContext';
import EnhancedUploadNotification from './EnhancedUploadNotification';

const AUTO_CLOSE_DELAY_MS = 5000;

const GlobalUploadNotification = () => {
  const {
    uploads,
    failedUploads,
    showNotification,
    cancelUpload,
    retryUpload,
    retryAllFailedUploads,
    renameAndRetryUpload,
    resumeInterruptedUploads,
    closeNotificationOnly,
    cancelAllUploads
  } = useUploadNotification();

  const autoCloseTimerRef = useRef(null);

  const uploadsInProgress = uploads.filter(
    upload => upload.status !== 'completed'
  );
  const allUploadsComplete = uploadsInProgress.length === 0 && uploads.length > 0;

  useEffect(() => {
    if (autoCloseTimerRef.current) {
      clearTimeout(autoCloseTimerRef.current);
      autoCloseTimerRef.current = null;
    }

    if (allUploadsComplete && failedUploads.length === 0 && showNotification) {
      autoCloseTimerRef.current = setTimeout(() => {
        closeNotificationOnly();
      }, AUTO_CLOSE_DELAY_MS);
    }

    return () => {
      if (autoCloseTimerRef.current) {
        clearTimeout(autoCloseTimerRef.current);
      }
    };
  }, [allUploadsComplete, failedUploads.length, showNotification, closeNotificationOnly]);

  const handleClose = () => {
    if (uploadsInProgress.length > 0) {
      cancelAllUploads();
    } else {
      closeNotificationOnly();
    }
  };

  if (!showNotification) {
    return null;
  }

  return (
    <div style={{ 
      position: 'fixed', 
      bottom: '20px', 
      right: '20px', 
      zIndex: 2000 
    }}>
      <EnhancedUploadNotification
        uploads={uploads}
        failedUploads={failedUploads}
        onClose={handleClose}
        onRemoveUpload={cancelUpload}
        onRetryUpload={retryUpload}
        onRetryAllFailed={retryAllFailedUploads}
        onRenameAndRetry={renameAndRetryUpload}
        onResumeInterrupted={resumeInterruptedUploads}
        onCancelAll={cancelAllUploads}
      />
    </div>
  );
};

export default GlobalUploadNotification; 